module.exports = __webpack_public_path__ + "static/media/police.eefffebe.png";